var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97.772 -271.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.848 284.729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.758,370.641a2.908,2.908,0,0,1-2.069-.857L139.7,366.8a.568.568,0,0,0-.785,0l-3,3a2.909,2.909,0,0,1-2.069.857h-.589l3.784,3.784a3.027,3.027,0,0,0,4.28,0l3.8-3.8Z",
    transform: "translate(-133.258 -366.639)",
    fill: "#3a2e83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.848 273.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.848,278.084a2.908,2.908,0,0,1,2.069.857l3,3a.556.556,0,0,0,.785,0l2.988-2.988a2.908,2.908,0,0,1,2.069-.857h.36l-3.8-3.8a3.027,3.027,0,0,0-4.28,0l-3.784,3.784Z",
    transform: "translate(-133.259 -273.413)",
    fill: "#3a2e83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.772 278.971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.882,321.494l-2.3-2.293a.44.44,0,0,1-.163.033h-1.047a2.073,2.073,0,0,0-1.453.6l-3,2.988a1.445,1.445,0,0,1-2.036,0l-3.011-3a2.073,2.073,0,0,0-1.454-.6h-1.287a.437.437,0,0,1-.155-.031l-2.312,2.3a3.018,3.018,0,0,0,0,4.28l2.312,2.3a.437.437,0,0,1,.155-.031h1.287a2.074,2.074,0,0,0,1.454-.6l3.011-3a1.479,1.479,0,0,1,2.036,0l3,2.988a2.073,2.073,0,0,0,1.454.6h1.047a.44.44,0,0,1,.163.033l2.3-2.293a3.018,3.018,0,0,0,0-4.28",
    transform: "translate(-99.772 -319.191)",
    fill: "#3a2e83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.8b8c209271a76fe3d1aa4f1aa4c0702d.svg";
export { ForwardRef as ReactComponent };